import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "./library/container";
import { ExpandItem } from "./library/expandItem";
class QuestionAnswer extends React.Component {
    render() {
        return ExpandItem({
            key: this.props.question,
            title: this.props.question,
            text: this.props.answer
        });
    }
    constructor(props){
        super(props);
    }
}
export const FaqBlock = (props)=>{
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsxs("section", {
            className: "block block--expand container--mg align--center",
            children: [
                props.title != "" && /*#__PURE__*/ _jsx("header", {
                    className: "block__header",
                    children: /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l container--xs",
                        children: props.title
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "block__content",
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "block__list expand__list",
                        children: props.entries.map((QA)=>/*#__PURE__*/ _jsx(QuestionAnswer, {
                                question: QA.question,
                                answer: QA.answer
                            }, QA.question)).toArray()
                    })
                })
            ]
        })
    });
};
{}